import React from 'react';
import { WheelAlignmentInfoLightBoxStore } from '../../_flux/stores/wheel_alignment_info_light_box_store';
import { WheelAlignmentInfoLightBox } from '../../_flux/components/wheel_alignment_info_light_box/wheel_alignment_info_light_box';
import { expandAction, hideAction } from '../../_flux/actions/wheel_alignment_info_light_box_actions';
import LightboxStore from '../../_flux/stores/lightbox_store';
import FittingStationStore from '../../_flux/stores/fitting_station_store';
import ActiveStationStore from '../../_flux/stores/active_station_store';
import { clickOnLearnMore, clickOnOk, clickOnRemove, close } from '../../_modules/google_analytics/wheel_alignment_info_light_box';
import { handleView } from '../handle_view';

const stores = {
    wheelAlignmentInfoLightBox: WheelAlignmentInfoLightBoxStore,
    lightBox: LightboxStore,
    fittingStation: FittingStationStore,
    activeStationState: ActiveStationStore,
};

function render(
    {
        wheelAlignmentInfoLightBox,
        lightBox,
        fittingStation,
        activeStationState,
    },
    options
) {
    const { visible, expanded } = wheelAlignmentInfoLightBox;
    const FSFLightBoxVisible = lightBox.visible;
    const detailModeStation = fittingStation.detailModeStation;
    const activeStation = activeStationState.activeStation;

    return (
        <WheelAlignmentInfoLightBox
            visible={visible}
            expanded={expanded}
            FSFLightBoxVisible={FSFLightBoxVisible}
            detailModeStation={detailModeStation}
            activeStation={activeStation}
            onExpand={onExpand}
            onAccept={onAccept}
            onClose={onClose}
            onRemove={options.onRemove}
        />
    );
}

const getOptions = options => ({
    ...options,
    onRemove: onRemoveFactory(options.onRemove),
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

const onExpand = () => {
    expandAction();
    clickOnLearnMore();
};

const onAccept = () => {
    hideAction();
    clickOnOk();
};

const onClose = () => {
    hideAction();
    close();
};

const onRemoveFactory = (onRemove) => () => {
    onRemove();
    clickOnRemove();
};
